import Axios from "axios";
import Authorization from './auth';
import { executeCall } from "./utils";

const crudder = (domain, resource, withAuth = true) => {
    const url = `${domain}/${resource}`;

    const getHeaders = () => withAuth ? Authorization() : {};

    return {
        get options() {
            return { headers: getHeaders(), url };
        },
        view: (uuid, extraMessages) => executeCall(() => Axios.get(url + `/${uuid}?extraMessages=${extraMessages ?? 4}`, { headers: getHeaders() })),
        send: (data, uuid) => executeCall(() => Axios.post(url + `/${uuid}`, data, { headers: getHeaders() })),
        markAsRead: (data) => executeCall(() => Axios.post(url + `/markRead`, data, { headers: getHeaders() })),
    };
};


export default crudder;